export const caseManagemetActions = {
  CLICK_CASE_MANAGEMENT_ACTIVITY_SUBMIT:
    "CLICK_CASE_MANAGEMENT_ACTIVITY_SUBMIT",
  CLICK_CASE_MANAGEMENT_CREATE_SUBMIT: "CLICK_CASE_MANAGEMENT_CREATE_SUBMIT",
  CLICK_CASE_MANAGEMENT_INSIGHTS_CREATE_SUBMIT:
    "CLICK_CASE_MANAGEMENT_INSIGHTS_CREATE_SUBMIT",
  CLICK_CASE_MANAGEMENT_UPDATE_SAVE: "CLICK_CASE_MANAGEMENT_UPDATE_SAVE",
  UPLOAD_CASE_MANAGEMENT_IMAGE: "UPLOAD_CASE_MANAGEMENT_IMAGE",
} as const;
